<nz-layout class="app-layout">
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <div class="left-side">
          <div class="sidebar-logo">
            <a routerLink="/dashboard">
              <img class="logo-fold" src="assets/icons/logo.png" alt="Logo" loading="eager">
            </a>
          </div>
        </div>
        <div class="right-side">
          <button nz-button nzType="dashed" (click)="logout()" class="logout-btn">Logout</button>
          <nz-avatar [nzGap]="1" [nzText]="initials" nzSize="large" class="user-avatar"></nz-avatar>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
